export default __webpack_public_path__ + "static/media/tram25.5247f278.svg";